import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import styled from "styled-components";
import { MdAddCircle } from "react-icons/md";
import mountainImg from '../PartnerSuper/mountain.jpg';
import { MdArrowBack } from "react-icons/md";
import { MdBusiness } from 'react-icons/md';
import { BsThreeDotsVertical } from "react-icons/bs";
import { BsArrowRepeat } from "react-icons/bs";
import { FaStar, FaRegStar } from "react-icons/fa";

const CustomToggle = React.forwardRef(({ onClick }, ref) => (
    <span
        ref={ref}
        onClick={(e) => {
            e.preventDefault();
            onClick(e);
        }}
        style={{ cursor: "pointer", fontSize: "18px" }}
    >
        <BsThreeDotsVertical />
    </span>
));

const reviewsData = [
    {
        initials: "ER",
        name: "Elena Rodriguez",
        date: "July 20, 2024 at 4:00 PM",
        spot: "Mountain View Peak",
        text: "Absolutely breathtaking views! A must-visit. The online ticket process was smooth.",
        rating: 4,
        hasPhoto: true
    },
    {
        initials: "JS",
        name: "John Smith",
        date: "August 10, 2024 at 11:30 AM",
        spot: "Sunrise Valley",
        text: "Amazing place! Clean and well organized.",
        rating: 5,
        hasPhoto: true
    },
    {
        initials: "AM",
        name: "Aisha Malik",
        date: "September 5, 2024 at 6:45 PM",
        spot: "Green Lake",
        text: "A peaceful retreat with stunning natural beauty.",
        rating: 4,
        hasPhoto: true
    }
];

const PartnerSuper = () => {
    const [activeTab, setActiveTab] = useState("reviews");
    const getBadgeClass = (status) => {
        switch (status) {
            case "Active":
                return "badge-opacity-success badge-rounded";
            case "Pending":
                return "badge-opacity-warning badge-rounded";
            case "Confirmed":
                return "badge-opacity-info badge-rounded";
            default:
                return "badge-opacity-primary badge-rounded";
        }
    };

    const getCategoryBadgeClass = (category) => {
        switch (category) {
            case "Travel & Tourism":
                return "badge-opacity-tourism badge-rounded";
            case "Adventure Sports":
                return "badge-opacity-adventure badge-rounded";
            case "Hospitality":
                return "badge-opacity-hospitality badge-rounded";
            default:
                return "badge-opacity-primary badge-rounded";
        }
    };

    const data = [
        {
            id: "P001",
            name: "Heritage Tours Pvt Ltd",
            logo: "https://via.placeholder.com/40",
            category: "Travel & Tourism",
            contact: "info@heritagetours.com | 9876543210",
            joinDate: "Jul 01, 2024",
            status: "Active",
        },
        {
            id: "P002",
            name: "Adventure Seekers Co.",
            logo: "https://via.placeholder.com/40",
            category: "Adventure Sports",
            contact: "support@adventureco.com | 9123456789",
            joinDate: "Jun 15, 2024",
            status: "Pending",
        },
        {
            id: "P003",
            name: "Food Fiesta Group",
            logo: "https://via.placeholder.com/40",
            category: "Hospitality",
            contact: "hello@foodfiesta.com | 9988776655",
            joinDate: "May 20, 2024",
            status: "Confirmed",
        },
    ];

    return (
        <Wrapper>
            <div className="container py-5">
                <div className="card border-0 shadow-sm p-4">
                    <div className="container mt-4">
                        <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap">
                            <div>
                                <h4 className="text-dark mb-1 d-flex align-items-center">
                                    Partner Management
                                </h4>
                                <p className="text-muted mb-0">
                                    Add, edit and manage partner profiles
                                </p>
                            </div>
                            <div className="mt-2 mt-md-0">
                                <button className="btn btn-primary d-flex align-items-center">
                                    <MdAddCircle className="me-2" size={20} />
                                    Add Partner
                                </button>
                            </div>
                        </div>
                        <div className="container p-0">
                            <div className="d-flex align-items-center flex-nowrap gap-2 mb-3 filter-box">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Search Name, ID, Category"
                                />
                                <select className="form-select">
                                    <option>All Categories</option>
                                </select>
                                <select className="form-select">
                                    <option>All Statuses</option>
                                </select>
                                <button className="btn btn-outline-secondary d-flex align-items-center gap-1">
                                    <BsArrowRepeat size={16} />
                                    Clear Filters
                                </button>
                            </div>
                            <div className="table-responsive">
                                <table className="table table-bordered align-middle">
                                    <thead className="table-light">
                                        <tr>
                                            <th>Logo</th>
                                            <th>Name</th>
                                            <th>Partner ID</th>
                                            <th>Categories</th>
                                            <th>Contact</th>
                                            <th>Join Date</th>
                                            <th>Status</th>
                                            <th className="text-center">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data.map((row, idx) => (
                                            <tr key={idx}>
                                                <td>
                                                    <img
                                                        src={mountainImg}
                                                        alt="logo"
                                                        style={{
                                                            width: 40,
                                                            height: 40,
                                                            borderRadius: "12%",
                                                        }}
                                                    />
                                                </td>
                                                <td>{row.name}</td>
                                                <td>{row.id}</td>
                                                <td>
                                                    <span className={getCategoryBadgeClass(row.category)}>
                                                        {row.category}
                                                    </span>
                                                </td>
                                                <td>{row.contact}</td>
                                                <td>{row.joinDate}</td>
                                                <td>
                                                    <span className={getBadgeClass(row.status)}>
                                                        {row.status}
                                                    </span>
                                                </td>
                                                <td className="text-center">
                                                    <Dropdown align="end">
                                                        <Dropdown.Toggle as={CustomToggle} />
                                                        <Dropdown.Menu>
                                                            <Dropdown.Item onClick={() => console.log("View", row)}>View Details</Dropdown.Item>
                                                            <Dropdown.Item onClick={() => console.log("Edit", row)}>Edit Partner</Dropdown.Item>
                                                            <Dropdown.Item onClick={() => console.log("Delete", row)}>Delete Partner</Dropdown.Item>
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container ">
                <div className="card border-0 shadow-sm p-4 bg-light">
                    <div className="container mt-4">
                        <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap">
                            <div>
                                <h4 className="text-dark mb-1 d-flex align-items-center">
                                    City Heritage Towers
                                </h4>
                                <p className="text-muted mb-0">
                                    Detail for city heritage tour
                                </p>
                            </div>
                            <div className="mt-2 mt-md-0">
                                <button className="btn btn-light d-flex align-items-center">
                                    <MdArrowBack className="me-2" size={20} />
                                    Back to partner
                                </button>
                            </div>
                        </div>
                        <CardWrapper className="shadow-sm p-4">
                            <div className="d-flex align-items-start">
                                <img
                                    src={mountainImg}
                                    alt="logo"
                                    style={{
                                        width: 40,
                                        height: 40,
                                        borderRadius: "12%",
                                    }}
                                />
                                <div className="ms-3">
                                    <h5 className="mb-1">City Heritage Tours</h5>
                                    <small className="text-muted d-flex align-items-center">
                                        <MdBusiness className="me-1" /> Organization
                                    </small>
                                </div>
                            </div>

                            <InfoGrid className="">
                                <div className="row ">
                                    <div className="col-lg-6 mb-3">
                                        <label>Contact Email</label>
                                        <p>contact@cityheritage.org</p>
                                    </div>
                                    <div className="col-lg-6 mb-3">
                                        <label>Phone Number</label>
                                        <p>123-456-7890</p>
                                    </div>
                                    <div className="col-lg-6 ">
                                        <label>Status</label>
                                        <span className="badge-status active">Active</span>
                                    </div>
                                    <div className="col-lg-6 ">
                                        <label>Joined Date</label>
                                        <p>1/15/2023</p>
                                    </div>
                                </div>
                            </InfoGrid>
                        </CardWrapper>

                        <CardWrapper className="shadow-sm p-4 mt-3">
                            <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link active" id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile" aria-selected="true">Profile</button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link" id="pills-listed-tab" data-bs-toggle="pill" data-bs-target="#pills-listed" type="button" role="tab" aria-controls="pills-listed" aria-selected="false">Listed Places</button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link" id="pills-gallery-tab" data-bs-toggle="pill" data-bs-target="#pills-gallery" type="button" role="tab" aria-controls="pills-gallery" aria-selected="false">Gallery</button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link" id="pills-rating-tab" data-bs-toggle="pill" data-bs-target="#pills-rating" type="button" role="tab" aria-controls="pills-rating" aria-selected="false">Rating & Review</button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link" id="pills-settlement-tab" data-bs-toggle="pill" data-bs-target="#pills-settlement" type="button" role="tab" aria-controls="pills-settlement" aria-selected="false">Settlement</button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link" id="pills-invoice-tab" data-bs-toggle="pill" data-bs-target="#pills-invoice" type="button" role="tab" aria-controls="pills-invoice" aria-selected="false">Invoice</button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link" id="pills-refund-tab" data-bs-toggle="pill" data-bs-target="#pills-refund" type="button" role="tab" aria-controls="pills-refund" aria-selected="false">Refund</button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link" id="pills-feedback-tab" data-bs-toggle="pill" data-bs-target="#pills-feedback" type="button" role="tab" aria-controls="pills-feedback" aria-selected="false">Suggestion & Feedback</button>
                                </li>
                            </ul>

                            <div className="tab-content" id="pills-tabContent">
                                <div className="tab-pane fade show active" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">
                                    <div className="row">
                                        <div className="col-lg-6" >
                                            <div className="border rounded p-3 h-100 shadow-sm">
                                                <h6 className="fw-bold mb-2">Bussiness Documents</h6>
                                                <p className="text-muted mb-0">Details to be implemented</p>
                                            </div>
                                        </div>
                                        <div className="col-lg-6" >
                                            <div className="border rounded p-3 h-100 shadow-sm">
                                                <h6 className="fw-bold mb-2">Bank Details</h6>
                                                <p className="text-muted mb-0">Details to be implemented</p>
                                            </div>
                                        </div>
                                        <div className="col-lg-6" >
                                            <div className="border rounded p-3 h-100 shadow-sm mt-3">
                                                <h6 className="fw-bold mb-2">GST Details</h6>
                                                <p className="text-muted mb-0">Details to be implemented</p>
                                            </div>
                                        </div>
                                        <div className="col-lg-6" >
                                            <div className="border rounded p-3 h-100 shadow-sm mt-3">
                                                <h6 className="fw-bold mb-2">Licences & Approvals</h6>
                                                <p className="text-muted mb-0">Details to be implemented</p>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div className="tab-pane fade" id="pills-listed" role="tabpanel" aria-labelledby="pills-listed-tab">
                                    <div className="col-lg-12">
                                        <div className="border rounded p-3 h-100 shadow-sm position-relative">
                                            <div className="d-flex justify-content-between align-items-start">
                                                {/* Left Content */}
                                                <div>
                                                    <h6 className="fw-bold mb-2">Place Name (State Museum)</h6>
                                                    <p className="text-muted mb-0">Place ID: os4853 </p>
                                                </div>

                                                {/* Dropdown Menu */}
                                                <div className="dropdown">
                                                    <button
                                                        className="btn p-0 border-0 bg-transparent"
                                                        type="button"
                                                        id="dropdownMenuButton"
                                                        data-bs-toggle="dropdown"
                                                        aria-expanded="false"
                                                    >
                                                        <BsThreeDotsVertical size={20} />
                                                    </button>
                                                    <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton">
                                                        <li><button className="dropdown-item">View Place Details </button></li>
                                                        <li><button className="dropdown-item">Edit Place</button></li>
                                                        <li><button className="dropdown-item">Rename Place </button></li>
                                                        <li><button className="dropdown-item">Delete Place</button></li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-12">
                                        <div className="border rounded p-3 h-100 shadow-sm position-relative mt-3">
                                            <div className="d-flex justify-content-between align-items-start">
                                                {/* Left Content */}
                                                <div>
                                                    <h6 className="fw-bold mb-2">Statue of Unity</h6>
                                                    <p className="text-muted mb-0">Place ID: os4853 </p>
                                                </div>

                                                {/* Dropdown Menu */}
                                                <div className="dropdown">
                                                    <button
                                                        className="btn p-0 border-0 bg-transparent"
                                                        type="button"
                                                        id="dropdownMenuButton"
                                                        data-bs-toggle="dropdown"
                                                        aria-expanded="false"
                                                    >
                                                        <BsThreeDotsVertical size={20} />
                                                    </button>
                                                    <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton">
                                                        <li><button className="dropdown-item">Place detail and their filled form​ </button></li>
                                                        <li><button className="dropdown-item">Online Form</button></li>
                                                        <li><button className="dropdown-item">Counter Form </button></li>
                                                        <li><button className="dropdown-item">QR Codes etc</button></li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane fade" id="pills-gallery" role="tabpanel" aria-labelledby="pills-gallery-tab">
                                    <div className="col-lg-12">
                                        <div className="border rounded p-3 h-100 shadow-sm position-relative">
                                            <div className="d-flex justify-content-between align-items-start">
                                                {/* Left Content */}
                                                <div>
                                                    <h6 className="fw-bold mb-2">Place Name (State Museum)</h6>
                                                    <p className="text-muted mb-0">Place ID: os4853 </p>
                                                </div>

                                                {/* Dropdown Menu */}
                                                <div className="dropdown">
                                                    <button
                                                        className="btn p-0 border-0 bg-transparent"
                                                        type="button"
                                                        id="dropdownMenuButton"
                                                        data-bs-toggle="dropdown"
                                                        aria-expanded="false"
                                                    >
                                                        <BsThreeDotsVertical size={20} />
                                                    </button>
                                                    <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton">
                                                        <li><button className="dropdown-item">View Place Details </button></li>
                                                        <li><button className="dropdown-item">Edit Place</button></li>
                                                        <li><button className="dropdown-item">Rename Place </button></li>
                                                        <li><button className="dropdown-item">Delete Place</button></li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-12">
                                        <div className="border rounded p-3 h-100 shadow-sm position-relative mt-3">
                                            <div className="d-flex justify-content-between align-items-start">
                                                {/* Left Content */}
                                                <div>
                                                    <h6 className="fw-bold mb-2">Statue of Unity</h6>
                                                    <p className="text-muted mb-0">Place ID: os4853 </p>
                                                </div>

                                                {/* Dropdown Menu */}
                                                <div className="dropdown">
                                                    <button
                                                        className="btn p-0 border-0 bg-transparent"
                                                        type="button"
                                                        id="dropdownMenuButton"
                                                        data-bs-toggle="dropdown"
                                                        aria-expanded="false"
                                                    >
                                                        <BsThreeDotsVertical size={20} />
                                                    </button>
                                                    <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton">
                                                        <li><button className="dropdown-item">Place detail and their filled form​ </button></li>
                                                        <li><button className="dropdown-item">Online Form</button></li>
                                                        <li><button className="dropdown-item">Counter Form </button></li>
                                                        <li><button className="dropdown-item">QR Codes etc</button></li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="card p-3 shadow-sm border-0 mb-3 mt-3">
                                        <div className="d-flex flex-wrap gap-3">
                                            <div className="container p-3">
                                                <div className="row">
                                                    <div className="col-lg-3 col-md-6 col-sm-12 ">
                                                        <div className="card shadow-sm border-0">
                                                            <img src={mountainImg} alt="Mountain View" className="mountain-img rounded-top" />
                                                            <div className="card-body">
                                                                <div className="fw-bold text-dark">Mountain View Peak</div>
                                                                <div className="text-muted small">By: Elena Rodriguez</div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-3 col-md-6 col-sm-12 pb-4">
                                                        <div className="card shadow-sm border-0">
                                                            <img src={mountainImg} alt="Mountain View" className="mountain-img rounded-top" />
                                                            <div className="card-body">
                                                                <div className="fw-bold text-dark">Sunset Cliffs</div>
                                                                <div className="text-muted small">By: Rahul Mehta</div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-3 col-md-6 col-sm-12 pb-4">
                                                        <div className="card shadow-sm border-0">
                                                            <img src={mountainImg} alt="Mountain View" className="mountain-img rounded-top" />
                                                            <div className="card-body">
                                                                <div className="fw-bold text-dark">Crystal Lake</div>
                                                                <div className="text-muted small">By: Sara Kim</div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-3 col-md-6 col-sm-12 pb-4">
                                                        <div className="card shadow-sm border-0">
                                                            <img src={mountainImg} alt="Mountain View" className="mountain-img rounded-top" />
                                                            <div className="card-body">
                                                                <div className="fw-bold text-dark">Majestic Falls</div>
                                                                <div className="text-muted small">By: RatherFord</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-3 col-md-6 col-sm-12 pb-4">
                                                        <div className="card shadow-sm border-0">
                                                            <img src={mountainImg} alt="Mountain View" className="mountain-img rounded-top" />
                                                            <div className="card-body">
                                                                <div className="fw-bold text-dark">Majestic Falls</div>
                                                                <div className="text-muted small">By: James Anderson</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane fade" id="pills-rating" role="tabpanel" aria-labelledby="pills-rating-tab">
                                    <div className="card border-0 shadow-sm p-4">
                                        <h4 className="fw-bold text-dark">Ratings & Reviews</h4>
                                        <p className="text-muted mb-4">
                                            See what users are saying and sharing about the partnered tourist spots.
                                        </p>
                                        <div className="d-flex mb-4">
                                            <button
                                                className={`btn me-2 border ${activeTab === "reviews" ? "btn-primary text-white" : "btn-light"}`}
                                                onClick={() => setActiveTab("reviews")}
                                            >
                                                All Reviews
                                            </button>
                                            <button
                                                className={`btn border ${activeTab === "photos" ? "btn-primary text-white" : "btn-light"}`}
                                                onClick={() => setActiveTab("photos")}
                                            >
                                                User Photos
                                            </button>
                                        </div>
                                        {activeTab === "reviews" && reviewsData.map((review, idx) => (
                                            <div className="card p-3 shadow-sm border-0 mb-3" key={idx}>
                                                <div className="d-flex justify-content-between">
                                                    <div>
                                                        <div className="d-flex align-items-start mb-3">
                                                            <div
                                                                className="rounded-circle bg-secondary text-white d-flex justify-content-center align-items-center me-2"
                                                                style={{ width: "35px", height: "35px", fontSize: "14px" }}
                                                            >
                                                                {review.initials}
                                                            </div>
                                                            <div>
                                                                <div className="fw-bold text-dark">{review.name}</div>
                                                                <div className="text-muted small">Reviewed on {review.date}</div>
                                                            </div>
                                                        </div>
                                                        <div className="fw-semibold text-dark">Spot: {review.spot}</div>
                                                        <p className="text-muted mb-2">{review.text}</p>
                                                        {review.hasPhoto && (
                                                            <button className="btn btn-outline-primary btn-sm">📷 Photo included</button>
                                                        )}
                                                    </div>
                                                    <div className="text-end">
                                                        {[...Array(review.rating)].map((_, i) => (
                                                            <FaStar key={i} size={18} color="#f6c000" />
                                                        ))}
                                                        {[...Array(5 - review.rating)].map((_, i) => (
                                                            <FaRegStar key={i} size={18} color="#f6c000" />
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        ))}

                                        {/* Photos Section */}
                                        {activeTab === "photos" && (
                                            <div className="card p-3 shadow-sm border-0 mb-3">
                                                <div className="d-flex flex-wrap gap-3">
                                                    <div className="container p-3">
                                                        <div className="row">
                                                            <div className="col-lg-3 col-md-6 col-sm-12 ">
                                                                <div className="card shadow-sm border-0">
                                                                    <img src={mountainImg} alt="Mountain View" className="mountain-img rounded-top" />
                                                                    <div className="card-body">
                                                                        <div className="fw-bold text-dark">Mountain View Peak</div>
                                                                        <div className="text-muted small">By: Elena Rodriguez</div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="col-lg-3 col-md-6 col-sm-12 pb-4">
                                                                <div className="card shadow-sm border-0">
                                                                    <img src={mountainImg} alt="Mountain View" className="mountain-img rounded-top" />
                                                                    <div className="card-body">
                                                                        <div className="fw-bold text-dark">Sunset Cliffs</div>
                                                                        <div className="text-muted small">By: Rahul Mehta</div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="col-lg-3 col-md-6 col-sm-12 pb-4">
                                                                <div className="card shadow-sm border-0">
                                                                    <img src={mountainImg} alt="Mountain View" className="mountain-img rounded-top" />
                                                                    <div className="card-body">
                                                                        <div className="fw-bold text-dark">Crystal Lake</div>
                                                                        <div className="text-muted small">By: Sara Kim</div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="col-lg-3 col-md-6 col-sm-12 pb-4">
                                                                <div className="card shadow-sm border-0">
                                                                    <img src={mountainImg} alt="Mountain View" className="mountain-img rounded-top" />
                                                                    <div className="card-body">
                                                                        <div className="fw-bold text-dark">Majestic Falls</div>
                                                                        <div className="text-muted small">By: RatherFord</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-3 col-md-6 col-sm-12 pb-4">
                                                                <div className="card shadow-sm border-0">
                                                                    <img src={mountainImg} alt="Mountain View" className="mountain-img rounded-top" />
                                                                    <div className="card-body">
                                                                        <div className="fw-bold text-dark">Majestic Falls</div>
                                                                        <div className="text-muted small">By: James Anderson</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>

                                </div>
                                <div className="tab-pane fade" id="pills-settlement" role="tabpanel" aria-labelledby="pills-settlement-tab">
                                    <div className="table-responsive">
                                        <table className="table table-bordered align-middle">
                                            <thead>
                                                <tr>
                                                    <th>Settlement ID</th>
                                                    <th>Partner Name</th>
                                                    <th>Period</th>
                                                    <th>Amount Due</th>
                                                    <th>Status</th>
                                                    <th>Payout Date</th>
                                                    <th>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td className="fw-semibold">S001</td>
                                                    <td>City Heritage Tours</td>
                                                    <td>Jun 1, 2024 - Jun 30, 2024</td>
                                                    <td>1250.75 USD</td>
                                                    <td>
                                                        <span className="badge bg-success bg-opacity-10 text-success fw-semibold">
                                                            Paid
                                                        </span>
                                                    </td>
                                                    <td>Jul 5, 2024</td>
                                                    <td>
                                                        <div className="dropdown">
                                                            <button
                                                                className="btn p-0 border-0"
                                                                type="button"
                                                                data-bs-toggle="dropdown"
                                                                aria-expanded="false"
                                                            >
                                                                <BsThreeDotsVertical />
                                                            </button>
                                                            <ul className="dropdown-menu dropdown-menu-end">
                                                                <li><button className="dropdown-item">View</button></li>
                                                                <li><button className="dropdown-item">Download</button></li>
                                                            </ul>
                                                        </div>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td className="fw-semibold">S004</td>
                                                    <td>City Heritage Tours</td>
                                                    <td>May 1, 2024 - May 31, 2024</td>
                                                    <td>1100.20 USD</td>
                                                    <td>
                                                        <span className="badge bg-success bg-opacity-10 text-success fw-semibold">
                                                            Paid
                                                        </span>
                                                    </td>
                                                    <td>Jun 5, 2024</td>
                                                    <td>
                                                        <div className="dropdown">
                                                            <button
                                                                className="btn p-0 border-0"
                                                                type="button"
                                                                data-bs-toggle="dropdown"
                                                                aria-expanded="false"
                                                            >
                                                                <BsThreeDotsVertical />
                                                            </button>
                                                            <ul className="dropdown-menu dropdown-menu-end">
                                                                <li><button className="dropdown-item">View</button></li>
                                                                <li><button className="dropdown-item">Download</button></li>
                                                            </ul>
                                                        </div>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td className="fw-semibold">S016</td>
                                                    <td>City Heritage Tours</td>
                                                    <td>Mar 31, 2024 - Apr 29, 2024</td>
                                                    <td>4515.94 USD</td>
                                                    <td>
                                                        <span className="badge bg-success bg-opacity-10 text-success fw-semibold">
                                                            Paid
                                                        </span>
                                                    </td>
                                                    <td>May 4, 2024</td>
                                                    <td>
                                                        <div className="dropdown">
                                                            <button
                                                                className="btn p-0 border-0"
                                                                type="button"
                                                                data-bs-toggle="dropdown"
                                                                aria-expanded="false"
                                                            >
                                                                <BsThreeDotsVertical />
                                                            </button>
                                                            <ul className="dropdown-menu dropdown-menu-end">
                                                                <li><button className="dropdown-item">View</button></li>
                                                                <li><button className="dropdown-item">Download</button></li>
                                                            </ul>
                                                        </div>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td className="fw-semibold">S031</td>
                                                    <td>City Heritage Tours</td>
                                                    <td>Jun 30, 2025 - Jul 30, 2025</td>
                                                    <td>4524.84 USD</td>
                                                    <td>
                                                        <span className="badge bg-success bg-opacity-10 text-success fw-semibold">
                                                            Paid
                                                        </span>
                                                    </td>
                                                    <td>Aug 4, 2025</td>
                                                    <td>
                                                        <div className="dropdown">
                                                            <button
                                                                className="btn p-0 border-0"
                                                                type="button"
                                                                data-bs-toggle="dropdown"
                                                                aria-expanded="false"
                                                            >
                                                                <BsThreeDotsVertical />
                                                            </button>
                                                            <ul className="dropdown-menu dropdown-menu-end">
                                                                <li><button className="dropdown-item">View</button></li>
                                                                <li><button className="dropdown-item">Download</button></li>
                                                            </ul>
                                                        </div>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td className="fw-semibold">S046</td>
                                                    <td>City Heritage Tours</td>
                                                    <td>Sep 30, 2026 - Oct 30, 2026</td>
                                                    <td>4929.60 USD</td>
                                                    <td>
                                                        <span className="badge bg-success bg-opacity-10 text-success fw-semibold">
                                                            Paid
                                                        </span>
                                                    </td>
                                                    <td>Nov 4, 2026</td>
                                                    <td>
                                                        <div className="dropdown">
                                                            <button
                                                                className="btn p-0 border-0"
                                                                type="button"
                                                                data-bs-toggle="dropdown"
                                                                aria-expanded="false"
                                                            >
                                                                <BsThreeDotsVertical />
                                                            </button>
                                                            <ul className="dropdown-menu dropdown-menu-end">
                                                                <li><button className="dropdown-item">View</button></li>
                                                                <li><button className="dropdown-item">Download</button></li>
                                                            </ul>
                                                        </div>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td className="fw-semibold">S061</td>
                                                    <td>City Heritage Tours</td>
                                                    <td>Dec 31, 2027 - Jan 30, 2028</td>
                                                    <td>3636.23 USD</td>
                                                    <td>
                                                        <span className="badge bg-success bg-opacity-10 text-success fw-semibold">
                                                            Paid
                                                        </span>
                                                    </td>
                                                    <td>Feb 4, 2028</td>
                                                    <td>
                                                        <div className="dropdown">
                                                            <button
                                                                className="btn p-0 border-0"
                                                                type="button"
                                                                data-bs-toggle="dropdown"
                                                                aria-expanded="false"
                                                            >
                                                                <BsThreeDotsVertical />
                                                            </button>
                                                            <ul className="dropdown-menu dropdown-menu-end">
                                                                <li><button className="dropdown-item">View</button></li>
                                                                <li><button className="dropdown-item">Download</button></li>
                                                            </ul>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="tab-pane fade" id="pills-invoice" role="tabpanel" aria-labelledby="pills-invoice-tab">
                                    <div className="card border-0">
                                        <div className="card-body">
                                            <h5 className="fw-bold mb-3">Associated Invoices</h5>
                                            <div className="table-responsive">
                                                <table className="table table-bordered align-middle">
                                                    <thead>
                                                        <tr>
                                                            <th>Invoice #</th>
                                                            <th>Issue Date</th>
                                                            <th>Due Date</th>
                                                            <th>Billed To</th>
                                                            <th>Type</th>
                                                            <th>Total Amount</th>
                                                            <th>Status</th>
                                                            <th>Actions</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td className="fw-semibold">INV-2024-07-001</td>
                                                            <td>Jul 15, 2024</td>
                                                            <td>Jul 30, 2024</td>
                                                            <td>Alice Wonderland</td>
                                                            <td>
                                                                <span className="badge bg-primary bg-opacity-10 text-primary fw-semibold">
                                                                    Booking
                                                                </span>
                                                            </td>
                                                            <td><strong>45.00 USD</strong></td>
                                                            <td>
                                                                <span className="badge bg-success bg-opacity-10 text-success fw-semibold">
                                                                    Paid
                                                                </span>
                                                            </td>
                                                            <td>
                                                                <div className="dropdown">
                                                                    <button
                                                                        className="btn p-0 border-0"
                                                                        type="button"
                                                                        data-bs-toggle="dropdown"
                                                                        aria-expanded="false"
                                                                    >
                                                                        <BsThreeDotsVertical />
                                                                    </button>
                                                                    <ul className="dropdown-menu dropdown-menu-end">
                                                                        <li><button className="dropdown-item">View</button></li>
                                                                        <li><button className="dropdown-item">Download</button></li>
                                                                    </ul>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane fade" id="pills-refund" role="tabpanel" aria-labelledby="pills-refund-tab">
                                    <div className="card border-0">
                                        <div className="card-body">
                                            <h5 className="fw-bold mb-3">Associated Refunds</h5>
                                            <div className="table-responsive">
                                                <table className="table table-bordered align-middle">
                                                    <thead>
                                                        <tr>
                                                            <th>Request ID</th>
                                                            <th>Booking ID</th>
                                                            <th>Partner Type</th>
                                                            <th>Partner</th>
                                                            <th>Customer</th>
                                                            <th>Reason</th>
                                                            <th>Requested Date</th>
                                                            <th>Amount</th>
                                                            <th>Status</th>
                                                            <th>Actions</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td className="fw-semibold">R002</td>
                                                            <td>B001</td>
                                                            <td>
                                                                <span className="badge bg-info bg-opacity-10 text-info fw-semibold">

                                                                    Organization
                                                                </span>
                                                            </td>
                                                            <td>City Heritage Tours</td>
                                                            <td>
                                                                Alice Wonderland
                                                                <br />
                                                                <small className="text-muted">555-0101</small>
                                                            </td>
                                                            <td>Changed plans</td>
                                                            <td>Jul 16, 2024, 5:00 PM</td>
                                                            <td>45.00 USD</td>
                                                            <td>
                                                                <span className="badge bg-warning bg-opacity-10 text-warning fw-semibold">
                                                                    Requested
                                                                </span>
                                                            </td>
                                                            <td>
                                                                <div className="dropdown">
                                                                    <button
                                                                        className="btn p-0 border-0"
                                                                        type="button"
                                                                        data-bs-toggle="dropdown"
                                                                        aria-expanded="false"
                                                                    >
                                                                        <BsThreeDotsVertical />
                                                                    </button>
                                                                    <ul className="dropdown-menu dropdown-menu-end">
                                                                        <li><button className="dropdown-item">View</button></li>
                                                                        <li><button className="dropdown-item">Take Action</button></li>
                                                                    </ul>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane fade" id="pills-feedback" role="tabpanel" aria-labelledby="pills-feedback-tab">

                                    <div className="card border-0 shadow-sm p-4 mb-4 bg-light">
                                        <div className="d-flex justify-content-between align-items-start">
                                            <h6 className="fw-bold text-dark mb-0">Dark Mode Option</h6>
                                            <span className="badge bg-light text-primary px-3 py-1 rounded-pill border border-primary">New</span>
                                        </div>
                                        <p className="text-muted small mt-2 mb-2">
                                            Submitted by: <strong>TechSavvy Venue</strong> on <span>Jul 22, 2024</span>
                                        </p>
                                        <p className="text-secondary mb-2">
                                            It would be great to have a dark mode option for the partner portal. It's easier on the eyes, especially during night shifts.
                                        </p>
                                        <p className="text-muted small mb-0">
                                            Type: <span className="text-primary fw-semibold">Feature Request</span>
                                        </p>
                                    </div>
                                    <div className="card border-0 shadow-sm p-4 mb-4 bg-light">
                                        <div className="d-flex justify-content-between align-items-start">
                                            <h6 className="fw-bold text-dark mb-0">Login Issues</h6>
                                            <span className="badge bg-light text-danger px-3 py-1 rounded-pill border border-danger">Urgent</span>
                                        </div>
                                        <p className="text-muted small mt-2 mb-2">
                                            Submitted by: <strong>GuestUser123</strong> on <span>Aug 2, 2024</span>
                                        </p>
                                        <p className="text-secondary mb-2">
                                            I’m unable to log into the dashboard after the last update. Please resolve it ASAP.
                                        </p>
                                        <p className="text-muted small mb-0">
                                            Type: <span className="text-danger fw-semibold">Complaint</span>
                                        </p>
                                    </div>
                                    <div className="card border-0 shadow-sm p-4 mb-4 bg-light">
                                        <div className="d-flex justify-content-between align-items-start">
                                            <h6 className="fw-bold text-dark mb-0">Add Multi-Language Support</h6>
                                            <span className="badge bg-light text-success px-3 py-1 rounded-pill border border-success">Reviewed</span>
                                        </div>
                                        <p className="text-muted small mt-2 mb-2">
                                            Submitted by: <strong>LocalTourOps</strong> on <span>Sep 10, 2024</span>
                                        </p>
                                        <p className="text-secondary mb-2">
                                            Please consider adding support for local languages to help regional partners.
                                        </p>
                                        <p className="text-muted small mb-0">
                                            Type: <span className="text-success fw-semibold">Suggestion</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </CardWrapper>

                        {/* nav tav */}

                    </div>
                </div>
            </div>
        </Wrapper>
    );
};

export default PartnerSuper;

const Wrapper = styled.div`
.badge-opacity-success {
  background-color: rgba(25, 135, 84, 0.15);
  color: #198754;
}
.badge-opacity-warning {
  background-color: rgba(255, 193, 7, 0.15);
  color: #856404;
}
.badge-opacity-info {
  background-color: rgba(13, 202, 240, 0.15);
  color: #0dcaf0;
}
.badge-opacity-primary {
  background-color: rgba(13, 110, 253, 0.15);
  color: #0d6efd;
}
.badge-rounded {
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 0.75rem;
  display: inline-block;
}
.table thead th {
  background-color: #f8f9fa;
}
.filter-box input,
.filter-box select {
  width: 169px !important;
}
.badge-opacity-tourism {
  background-color: rgba(0, 123, 255, 0.15);
  color: #007bff;
}
.badge-opacity-adventure {
  background-color: rgba(255, 193, 7, 0.15);
  color: #ffc107;
}
.badge-opacity-hospitality {
  background-color: rgba(40, 167, 69, 0.15);
  color: #28a745;
}

  .card.p-3.shadow-sm.border-0 {
    background-color: #fafafa !important;
  }

  .mountain-img {
    width: 100%;
    height: 180px;
    object-fit: cover;
  }
`










const CardWrapper = styled.div`
  background: white;
  border-radius: 10px;

`;



const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
  margin-top: 20px;

  label {
    font-size: 0.85rem;
    font-weight: 600;
    color: #333;
    display: block;
  }

  p {
    margin: 0;
    font-size: 0.9rem;
    color: #555;
  }

  .badge-status {
    padding: 4px 10px;
    border-radius: 20px;
    font-size: 0.75rem;
    display: inline-block;
  }

  .active {
    background-color: rgba(25, 135, 84, 0.15);
    color: #198754;
  }
`;

;
